import './bootstrap';
import '../css/app.css';
import './Partials/icon';

import { createApp, h } from 'vue';
import { createInertiaApp, router } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { ToastPlugin } from '@bpmlib/vue-satoast';
import { initMatomo } from '@certible/use-matomo';
import { Tooltip, Dropdown } from 'floating-vue';
import { ZiggyVue } from 'ziggy-js';

import 'floating-vue/dist/style.css';
import 'vue-select/dist/vue-select.css';
import '@bpmlib/vue-sabutton/style.css';
import '@bpmlib/vue-saform/style.css';
import '@bpmlib/vue-saform/style.css';
import '@bpmlib/vue-saform/quill.css';
import '@bpmlib/vue-satoast/style.css';
import '@bpmlib/vue-salayout/style.css';
import '@bpmlib/vue-samodal/style.css';
import '@bpmlib/vue-sapaginator/style.css';
import '@bpmlib/vue-satable/style.css';
import '@bpmlib/vue-satabs/style.css';

const matomo =
  import.meta.env.MODE === 'production' && import.meta.env.VITE_MATOMO_HOST && import.meta.env.VITE_MATOMO_SITE_ID
    ? initMatomo({
        host: import.meta.env.VITE_MATOMO_HOST,
        siteId: import.meta.env.VITE_MATOMO_SITE_ID,
      })
    : null;

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';
createInertiaApp({
  title: (title) => (title ? `${title} — ${appName}` : appName),
  resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
  progress: {
    color: '#f00',
    showSpinner: true,
  },
  setup({ el, App, props, plugin }) {
    const app = createApp({ render: () => h(App, props) })
      .use(plugin)
      .component('v-tooltip', Tooltip)
      .component('v-dropdown', Dropdown)
      .component('font-awesome-icon', FontAwesomeIcon)
      .use(ToastPlugin)
      .use(ZiggyVue);

    if (matomo) {
      app.provide('matomo', matomo);
    }

    return app.mount(el);
  },
});

if (matomo) {
  let lastUrl = null;
  router.on('navigate', (event) => {
    const { url } = event.detail.page;
    if (url === lastUrl) return;
    lastUrl = url;
    matomo.trackPageView(url);
  });
}
